import { useBuiltComponent } from "./useBuiltComponent";
import { useCampaignVariants } from "../../campaign-built/composables/useCampaignVariants";
export const useDefaultVariant = (componentId) => {
    const { builtComponent } = useBuiltComponent(componentId);
    const { defaultVariant } = useCampaignVariants(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id; });
    return { defaultVariant };
};
